import React, { useState, memo, useEffect } from "react";
import { View } from "react-native";
import CustomTopTabs from "../CustomTopTabs/CustomTopTabs";
import { RequestHistoryProps } from "./types";
import ItemList from "./ItemList/ItemList";
import styled from "styled-components/native";
import { filteredProductArray } from "./utils/utils";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { PriceModes } from "../PriceModeCard/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useSelector } from "react-redux";
import { useAppSettings } from "@redux/slices/globalSlice";
import Routes from "@navigations/Routes";
import { navigate } from "@navigations/utils/RootNavigation";
import { useTheme } from "styled-components/native";
import { useTokenPresence } from "../../../hooks/useTokenPresnece";

const RequestHistory = (props: RequestHistoryProps) => {
  const userInfo = useUserInfo();
  const isPaFeatureEnabled = userInfo.user.purchasing_agent_enabled;
  const isPurchasingAgent = userInfo.isPAUserSalesPerson();
  const priceMode = userInfo.user.price_mode;
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);
  const hasToken = useTokenPresence();
  const theme = useTheme();
  const isSalesPerson =
    !userInfo.forceGreenPriceProfile() &&
    userInfo.priceProfileVisibility() &&
    !userInfo.isPriceModeLock() &&
    priceMode === PriceModes.ORANGE;
  const isSupplierPerson =
    !userInfo.forceGreenPriceProfile() &&
    userInfo.priceProfileVisibility() &&
    priceMode === PriceModes.WHITE;
  const enableAskQuestion =
    userInfo.user?.price_mode === PriceModes.ORANGE &&
    userInfo.isPriceModeLock();
  const getAppSettings = useAppSettings();

  let productArray =
    filteredProductArray(
      isPaFeatureEnabled,
      isPurchasingAgent,
      isSalesPerson,
      isSupplierPerson,
      userInfo.user.price_mode,
      !enableAskQuestion,
      props.selectedIndex === 0,
      userInfo.userCanShowMemoInOrangeMode(),
      userInfo.isPAUserOrPASalesPerson(),
      userInfo.priceModeLockedInOrangeMode(),
      isCustomApp,
      getAppSettings.allowed_request_types
    ) || [];

  const [isReceivedRequest] = useState(props.requestType === "received");
  const [selectedTab, setSelectedTab] = useState("all");

  useEffect(() => {
    if (productArray.length === 1) {
      setSelectedTab(productArray[0].producttypes);
    }
  }, [productArray, priceMode]);

  useEffect(() => {
    if (productArray.length !== 1 && priceMode === PriceModes.WHITE) {
      setSelectedTab("all");
    }
  }, [priceMode]);

  if (!userInfo.enableSellReturnButton()) {
    productArray = productArray.filter(
      (item) => item.producttypes !== "sold" && item.producttypes !== "return"
    );
  }

  const handleCardClick = (clickedItem: any) => {
    setSelectedTab(clickedItem.producttypes);
    if (theme.isLargeScreen || theme.isTablet) {
      navigate(Routes.ChooseARequestScreen);
    }
  };

  return (
    <View style={{ flex: 1 }}>
      {productArray.length > 1 && (
        <CustomTopTabs
          productArray={productArray}
          handleCardClick={handleCardClick}
          menuItemEventName=""
          tabWidth={83}
          tabGap={SpaceType.Basic}
          shouldUseFlexGrow={isCustomApp ? false : true}
        />
      )}
      <DataContainer>
        {hasToken && (
          <ItemList
            isReceivedRequest={isReceivedRequest}
            selectedTab={selectedTab}
            requestedItem={props?.requestedItem}
          />
        )}
      </DataContainer>
    </View>
  );
};

const DataContainer = styled.View`
  position: relative;
  flex: 1;
`;

export default memo(RequestHistory);
